import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ThemeButtonKeys } from '../../../styles/tokens/buttons';
import { LinkType } from '../../../types';
import { IconMap } from '../../icon/cmsIcons';
import Link from '../../link/Link';
import Button from '../../button/Button';

// Interface

export interface LinkButtonProps {
  buttonVariant?: ThemeButtonKeys | "link";
  link: LinkType;
  icon?: keyof typeof IconMap; 
  dataLayerClickContext?: string;
}

// Styles

const StyledLinkButton = styled.div`
  ${({ theme: { space, colors, media } }) => css`
    background: ${colors.zemplerBlue};
    padding: ${space.fluidMediumToLarge};
  `};
`;

// JSX

export const LinkButton: FC<LinkButtonProps> = ({ buttonVariant, link, icon, dataLayerClickContext }) => {
  let Icon = null;

  // Check that all icons are defined
  Object.entries(IconMap).forEach(([key, value]) => {
    if (!value) {
      console.error(`Icon with key ${key} is undefined.`);
    }
  });

  if (icon) {
    const normalizedIcon = icon.replace(/\s+/g, "");
    const dynamicIconKey =
      normalizedIcon.charAt(0).toUpperCase() + normalizedIcon.slice(1);
    Icon = IconMap[dynamicIconKey as keyof typeof IconMap];
  }
  return (
  <>
   {buttonVariant === "link" ? (
        <Link
         {...link}
         dataLayerClickContext={dataLayerClickContext}
        />
      ) : (
        <Button
          variant={buttonVariant}
          iconRight={Icon && <Icon size="small" />}
          {...link}
          dataLayerClickContext={dataLayerClickContext}
        />
      )}
  
  </>
)};

export default LinkButton;
